// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Sv6z","top":"styles_top__4tKAx","left":"styles_left__3SpkZ","description":"styles_description__3VAX1"};